<template>
    <div class="secret-auth">
        <div class="secret-auth-content">
            <steps-head :title="$t('填写 Secret，授权企点获取企业微信通讯录')"></steps-head>
            <v-form ref="secretForm">
                <v-form-item v-model="secretError" name="secret" error-placement="bottom">
                    <v-input
                        v-model="secretVal"
                        name="secret"
                        class="secret-auth-input"
                        :placeholder="$t('请输入 Secret')"
                        :width="490"
                    ></v-input>
                </v-form-item>
            </v-form>
            <p class="secret-auth-txt">
                {{ $t('请在 「企业微信后台 - 管理工具 - 通讯录同步」中开启API接口同步，并在查看 Secret 后复制过来') }}
            </p>
            <div class="secret-auth-image"></div>
        </div>
        <steps-bottom :is-last-step="isLastStep" :btn-disabled="btnDisabled" @btnClick="onBtnClick"></steps-bottom>
    </div>
</template>

<script>
import Gateway from '@/utils/Gateway';
import StepsHead from '../../steps-head';
import StepsBottom from '../../steps-bottom';

export default {
    components: {
        StepsHead,
        StepsBottom
    },

    props: {
        isLastStep: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            secretVal: '',
            secretError: '',
            reqing: false
        };
    },

    computed: {
        btnDisabled() {
            return !this.secretVal;
        }
    },

    methods: {
        onBtnClick() {
            if (this.reqing) {
                return;
            }

            this.reqing = true;

            Gateway.get('/v1/account/wework/ValidateCorpSecret', { secret: this.secretVal })
                .then(() => {
                    this.reqing = false;
                    this.$message.success(this.$t('授权通讯录成功'));
                    this.$emit('success');
                })
                .catch(() => {
                    this.reqing = false;
                    this.showError();
                    this.$emit('error');
                });
        },

        showError() {
            this.secretError = this.$t('请填写正确的Secret');
            this.$nextTick(() => {
                this.$refs.secretForm.focusError();
            });
        }
    }
};
</script>
<style scoped lang="less">
@import './secret-auth.less';
</style>
